import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import s from './AdminHeader.module.css';
import { ReactComponent as AdminLogo } from '../../../assets/icons/AdminLogo.svg';
import { useAuth } from '../../contexts/AuthContext';

interface AdminHeaderProps {
    onBurgerClick?: () => void;
}

export const AdminHeader: React.FC<AdminHeaderProps> = ({ onBurgerClick }) => {
    const navigate = useNavigate();
    const { logout } = useAuth();

    const handleLogout = () => {
        logout();
        navigate('/admin/login');
    };

    return (
        <header className={s.adminHeader}>
            <div className={s.headerLeft}>
                <button className={s.burgerBtn} onClick={onBurgerClick}>
                    ☰
                </button>
                <Link to="/admin" className={s.logo}>
                    <AdminLogo className={s.logoIcon}/>
                </Link>
            </div>
            <div className={s.headerRight}>
                <button className={s.logoutBtn} onClick={handleLogout}>
                    Выйти
                </button>
            </div>
        </header>
    );
};